import { useEffect, useState } from "react";
import Mode from "../../components/styles/Mode";
import { useDispatch } from "react-redux";
import Flexbox from "../../components/Flexbox";
import Spacebox from "../../components/Spacebox";
import '../../css/turboform.css'
import { isValidEmail } from "../../utilities/utils";
import requests from "../../handlers/requests";
import { useNavigate } from "react-router-dom";
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import NoticeText from "../../components/NoticeText";


const CuraForm = () => {


    // recieves email, phone, first name, last name, contact_id, saved & error
    // if save = false:
    //    collect debt_amount & state and send to server to create new traffic collection and send to GHL
    // else:
    //    update user details in db
    // send to /turbo url params contact_id & source=ghl-survey

    const dispatch = useDispatch()

    const navigate = useNavigate()


    const [email, setEmail] = useState('')

    const [error, setError] = useState(null)

    const [isLoading, setIsLoading] = useState(false)

    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })


    const saveOrUpdateUser = () => {
        if (isValidEmail(email)) {
            getUser()
        } else {
            setError('Invalid Email address')
            scrollToTop()
        }
    }

    const getUser = () => {
        setIsLoading(true)
        requests.get(`/api/users/dynamic/email/${email}`, () => { }, () => { }, setError, setIsLoading,
            (res) => {
                setIsLoading(false)
                sendToCura(res.data.contact_id)
            },
            null,
            (res) => {
                setIsLoading(false)
                setError(res.msg)
            }
        )
    }

    const sendToCura = (contactId) => {
        navigate(`/cura?contact_id=${contactId}&source=turbo-empty-cart&page=lf`, { replace: true })
    }

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="turbo-form-page" data-clarity-mask="true" style={{ padding: '0px 20px' }}>
                <Spacebox padding="10px" />
                {(
                    <div className="margin-auto mid " style={{ boxShadow: '0px 0px 20px #00000030' }}>
                        <div className="survey-copy">
                            <div className="margin-auto" style={{ padding: '40px' }}>
                                <span style={{ fontWeight: '700', fontSize: 25, textAlign: 'left' }} className="text-primary heading bold hide-on-med-and-down">
                                    Enter the user email
                                </span>
                                <span style={{ fontWeight: '700', fontSize: 22, textAlign: 'left' }} className="text-primary heading bold hide-on-large-only">
                                    Enter the user email
                                </span>
                                <Spacebox padding="10px" />
                                <span style={{ fontSize: 14 }}>
                                    <i style={{ opacity: .6 }}>
                                        <b className="bold open-sans">Provide email of user you want to send to turbo</b>
                                    </i>
                                </span>
                                <Spacebox padding="10px" />
                                {/* Error message */}
                                {error && <div>
                                    <div style={{ background: 'rgba(255, 0, 0, 0.05)', padding: '10px', textAlign: 'center' }}>
                                        <Flexbox alignItems="center">
                                            <img src="/svgs/alert-circle-red.svg" alt="warning" style={{ width: 15 }} />
                                            <Spacebox padding="5px" />
                                            <small>
                                                <b className="trade-red">{error}</b>
                                            </small>
                                        </Flexbox>
                                    </div>
                                    <Spacebox padding="10px" />
                                </div>}
                                <Spacebox padding="10px" />
                                <div>
                                    <small style={{ fontSize: 14 }} className="open-sans"><b>Email</b></small>
                                    <Spacebox padding="2px" />
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <Spacebox padding="10px" />
                                <NoticeText />
                            </div>
                        </div>
                        <div style={{ background: '#00359e', height: 50, display: 'flex', justifyContent: 'flex-end' }}>
                            <div onClick={saveOrUpdateUser} style={{ background: 'rgb(255, 161, 0)', padding: '17px 24px', cursor: 'pointer' }}>
                                <span style={{ fontSize: 15 }} className="text-white">
                                    {!isLoading && "SUBMIT"}
                                    {isLoading && "PLEASE WAIT..."}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                <Spacebox padding="10px" />
            </div>
        </Mode >
    );
}

export default CuraForm;